import SectionLast from './sectionlast/SectionLast';
import NavbarUi from './navbar/navbar';
import HeroSection from './herosection/hero';
import Features from './features/features';
import About from './about/about';
import Tokens from './tokens/tokens';
import SmoothScroll from './SmoothScroll';
import Footer from './footer/footer';
import BlogSection from './blog/blogsection';

function LandingPage() {

    return (
        <div className="min-h-screen">
            <SmoothScroll>
                <NavbarUi />
                <HeroSection />
                <Features />
                <About />
                <Tokens />
                <BlogSection />
                <SectionLast />
                <Footer />
            </SmoothScroll>
        </div>
    );
}

export default LandingPage;